import TitleContentInput from './title-content-input'

export default TitleContentInput
